// ---- Book Tracking Types ----

export type ReadingStatus = "want_to_read" | "reading" | "finished";

export const BOOK_GENRES = [
  "Fiction",
  "Non-Fiction",
  "Science Fiction",
  "Fantasy",
  "Romance",
  "Thriller",
  "Mystery",
  "Biography",
  "Self-Help",
  "History",
  "Science",
  "Business",
  "Poetry",
  "Horror",
  "Other",
] as const;

export type BookGenre = (typeof BOOK_GENRES)[number];

export type Book = {
  id: string;                    // Firestore doc ID
  userId: string;
  title: string;
  author: string;
  coverUrl?: string;             // Google Books thumbnail
  genre?: string;
  pageCount?: number;
  currentPage: number;           // 0 if not started
  status: ReadingStatus;
  rating?: number;               // 1-5 stars
  review?: string;               // Personal notes
  googleBooksId?: string;        // For deduplication
  dateAdded: string;             // ISO date
  dateStarted?: string;          // When moved to "reading"
  dateFinished?: string;         // When moved to "finished"
};

export type GoogleBooksResult = {
  id: string;
  title: string;
  authors: string[];
  thumbnail?: string;
  pageCount?: number;
  categories?: string[];
  description?: string;
};

/** Shared book catalog — community-populated, not per-user */
export type CatalogBook = {
  id: string;                    // Firestore doc ID
  title: string;
  titleLower: string;            // lowercase for case-insensitive search
  author: string;
  authorLower: string;           // lowercase for search
  coverUrl?: string;
  genre?: string;
  pageCount?: number;
  googleBooksId?: string;        // link to Google Books (if originated there)
  description?: string;
  addedBy: string;               // userId of first person to add
  readersCount: number;          // how many users have this book
  avgRating: number;             // community average rating
  totalRatings: number;          // number of ratings
  createdAt: string;             // ISO date
  updatedAt: string;             // ISO date
};
